import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

export interface ComponentCanDeactivate {
    canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
    canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
        // if there are no unsaved changes, just allow deactivation; else confirm first
        return component.canDeactivate()
            ? true
            : confirm('You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.');
    }
}
